import {
  __async
} from "./chunk--chunk-RQ7252KT.js";

// src/js/components/Slider.js
var Slider = class {
  constructor(el, sel) {
    this.el = el;
    this.options = JSON.parse(el.getAttribute(sel));
    if (this.el.getAttribute("data-upsell-slider")) {
      this.upsellInit = true;
      this.removedProducts = [];
    }
    if (this.el.hasAttribute("data-sticky-ticker")) {
      this.el.parentNode.style.zIndex = 1e9;
    }
    this.initSplide();
  }
  initSplide() {
    return __async(this, null, function* () {
      let Splide = yield import("./chunk--splide.esm-YQO2Z6HR.js");
      Splide = Splide.default;
      this.mainSlider = new Splide(this.el, this.options);
      if (this.el.parentNode.querySelector("[data-connected-slider]")) {
        this.connectedEl = this.el.parentNode.querySelector("[data-connected-slider]");
        const connectedOptions = JSON.parse(this.connectedEl.getAttribute("data-connected-slider"));
        this.connectedSlider = new Splide(this.connectedEl, connectedOptions);
      }
      if (this.connectedSlider)
        this.initConnectedSlider();
      this.mainSlider.mount();
      if (this.el.hasAttribute("data-instant-style-change")) {
        this.mainSlider.on("move", (newIndex) => {
          this.instantStyleChange(this.mainSlider, newIndex);
        });
      }
      this.initVideoHandler();
      if (this.upsellInit) {
        this.initUpsellAddRemove();
      }
      document.addEventListener("variant update", (e) => {
        this.mainSlider.Components.Slides.forEach((slide) => {
          const image = slide.slide.querySelector("img");
          if (!image)
            return;
          const alt = image.getAttribute("alt").split("|variant ")[1];
          if (alt && alt.length > 0) {
            const altCheck = alt.replaceAll(" ", "");
            const valueCheck = e.detail.value.replaceAll(" ", "");
            if (altCheck === valueCheck && slide.slide.hasAttribute("data-index")) {
              const goToIndex = parseInt(slide.slide.getAttribute("data-index"));
              this.mainSlider.go(goToIndex);
            }
          }
        });
      });
      document.dispatchEvent(new CustomEvent("variant change listener attached"));
    });
  }
  initConnectedSlider() {
    this.mainSlider.on("move", (newIndex) => {
      this.connectedSlider.go(newIndex);
      if (this.connectedEl.hasAttribute("data-is-navigation")) {
        this.instantStyleChange(this.connectedSlider, newIndex);
      }
    });
    this.connectedSlider.on("move", (newIndex) => {
      this.mainSlider.go(newIndex);
      if (this.connectedEl.hasAttribute("data-is-navigation")) {
        this.instantStyleChange(this.connectedSlider, newIndex);
      }
    });
    this.connectedSlider.mount();
  }
  // ensures no delay in changing slide for navigation slider
  instantStyleChange(slider, index) {
    slider.Components.Slides.forEach((slide) => {
      if (slide.index === index) {
        slide.slide.classList.add("is-active");
      } else {
        slide.slide.classList.remove("is-active");
      }
    });
  }
  initVideoHandler() {
    const { Components: { Slides } } = this.mainSlider;
    this.currentSlide = Slides.getAt(0).slide;
    document.addEventListener("video end", (e) => {
      const _video = this.currentSlide.querySelector("video");
      if (e.detail && e.detail.video === _video && e.detail.changeSlide) {
        this.mainSlider.go(">");
      }
    });
    let hasVideo = false;
    Slides.forEach((slide) => {
      if (slide.slide.querySelector("video")) {
        hasVideo = true;
      }
    });
    this.mainSlider.on("move", (newIndex, prevIndex) => {
      this.currentSlide = Slides.getAt(newIndex).slide;
      const currentVideo = Slides.getAt(newIndex).slide.querySelector("video");
      if (currentVideo) {
        setTimeout(() => {
          currentVideo.play();
        }, 250);
      }
      const lastVideo = Slides.getAt(prevIndex).slide.querySelector("video");
      if (lastVideo) {
        setTimeout(() => {
          lastVideo.pause();
        }, 250);
      }
      if (hasVideo && !currentVideo) {
        setTimeout(() => {
          this.mainSlider.go(newIndex + 1);
        }, 5e3);
      }
    });
  }
  initUpsellAddRemove() {
    return __async(this, null, function* () {
      const updateSlides = () => __async(this, null, function* () {
        try {
          const res = yield fetch("/cart.js");
          const state = yield res.json();
          const productHandles = state.items.map((item) => item.handle);
          const { Components: { Slides } } = this.mainSlider;
          Slides.forEach((slide) => {
            if (productHandles.includes(slide.slide.getAttribute("data-product-handle"))) {
              this.removedProducts.push(slide);
              this.mainSlider.remove(slide.index);
            }
          });
          this.removedProducts.forEach((product) => {
            if (!productHandles.includes(product.slide.getAttribute("data-product-handle"))) {
              this.mainSlider.add(product.slide);
            }
          });
        } catch (err) {
          console.error(err);
        }
      });
      document.addEventListener("ajaxcart refresh", updateSlides);
      updateSlides();
    });
  }
};
var Slider_default = Slider;
export {
  Slider_default as default
};
